<div class="flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
  <h1 class="text-4xl font-bold text-gray-800 mb-4">Oops! This page is steeping...</h1>
  <p class="text-lg text-gray-600 mb-8">We're sorry, but the page you're looking for isn't quite ready to be served yet.</p>
  
  <div class="grid md:grid-cols-[repeat(auto-fit,minmax(0,500px))] gap-8 max-w-4xl w-full justify-center">
    <div *booleanFeatureFlag="'enable-404-newsletter'; default: false" class="bg-white p-6 rounded-lg shadow-md flex flex-col">
      <div>
        <h2 class="text-2xl font-semibold text-gray-800 mb-3">Stay in the Loop</h2>
        <p class="text-gray-600 mb-4">Sign up for our newsletter to be notified when this page is ready!</p>
      </div>
      <tea-shop-fe-subscribe-block buttonClasses="mt-auto w-full px-6 py-3 bg-green-800 hover:bg-green-900 text-white rounded-lg transition-colors duration-200"></tea-shop-fe-subscribe-block>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md flex flex-col">
      <div>
        <h2 class="text-2xl font-semibold text-gray-800 mb-3">Need Assistance?</h2>
        <p class="text-gray-600 mb-4">We're here to help! Feel free to reach out through our contact form.</p>
      </div>
      <button routerLink="/contact" class="mt-auto w-full px-6 py-3 bg-green-800 hover:bg-green-900 text-white rounded-lg transition-colors duration-200">
        Contact Us
      </button>
    </div>
  </div>

  <a routerLink="/" class="mt-8 text-green-800 hover:text-green-900 underline transition-colors duration-200">
    Return to Home Page
  </a>
</div>
